<template>
  <div class="breadcrumb__container">
    <ul
      class="breadcrumb"
      :class="[
        { 'breadcrumb__incomplete': step === 1 },
        { 'breadcrumb__complete': step === 2 },
      ]"
    >
      <li>
        <span class="breadcrumb__bullet">
          <span class="breadcrumb__number">1</span>
        </span>
        <span class="breadcrumb__text">{{ $t(`${namespace}.general`) }}</span>
      </li>

      <li>
        <span class="breadcrumb__bullet">
          <span class="breadcrumb__number">2</span>
        </span>
        <span class="breadcrumb__text">{{ $t(`${namespace}.financial`) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyDataPage.breadcrumb'
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb__container {
  padding: 0 0 25px;
  text-align: center;
}

.breadcrumb {
  display: inline-block;
  list-style-type: none;
  margin: 0 auto;
  padding: 0 0 20px;
  position: relative;

  &:before,
  &:after {
    content: '';
    display: block;
    height: 2px;
    left: 30px;
    position: absolute;
    right: 30px;
    top: 18px;
  }

  &:before {
    background-color: #d6d6d6;
  }

  &:after {
    background-color: #2dcc70;
    right: 70px;
  }

  &.breadcrumb__incomplete {

    &:after {
      right: 70px;
    }

    li:first-child {

      .breadcrumb__bullet {
        border-color: #2dcc70;
        background-color: #f6f5f6;
      }

      .breadcrumb__number {
        background-color: #2dcc70;
      }

      .breadcrumb__text {
        color: #2dcc70;
        font-weight: 600;
      }
    }
  }

  &.breadcrumb__complete {

    &:after {
      right: 30px;
    }

    li {

      .breadcrumb__bullet {
        border-color: #2dcc70;
        background-color: #f6f5f6;
      }

      .breadcrumb__number {
        background-color: #2dcc70;
      }

      .breadcrumb__text {
        color: #2dcc70;
        font-weight: 600;
      }
    }
  }

  li {
    display: inline-block;
    position: relative;
    text-align: center;
    z-index: 1;

    & + li {
      margin-left: 60px
    }
  }
}

.breadcrumb__bullet {
  border: 1px solid transparent;
  border-radius: 50%;
  display: inline-block;
}

.breadcrumb__text {
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  left: 50%;
  margin-top: 8px;
  position: absolute;
  text-transform: uppercase;
  top: 100%;
  transform: translateX(-50%);
}

.breadcrumb__number {
  align-items: center;
  background-color: #d6d6d6;
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 700;
  height: 24px;
  justify-content: center;
  margin: 6px;
  width: 24px;
}

.breadcrumb__text {
  color: #757575;
}
</style>
